// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604292242/js/" + chunkId + "." + {"44":"7e91551d","225":"e34d9f6e","481":"61e8dd7f","486":"53277684","770":"6849c26c"}[chunkId] + ".0.9723098236394376.chunk.js";
};